import moment from 'moment-timezone';
import Constants from '@/utils/constants';

function isValidDateFormat (value, format) {
  const date = moment(value);
  return date.isValid() ? date.format(format) : null;
}

function userLocalDateTimeFormat (dateValue, format = Constants.UserLocaleDateTimeFormat) {
  return isValidDateFormat(dateValue, format);
}

function getLocalTimezoneAbbreviation() {
  return moment.tz(moment.tz.guess()).zoneAbbr();
}

function getDurationAsMinute(date1, date2) {  
  const mDate1 = moment(date1).isValid()
    ? moment(date1) : null; 
  const mDate2 = moment(date2).isValid()
    ? moment(date2) : null;
  if (mDate1 && mDate2) {
    const difference = moment(mDate2).diff(moment(mDate1));
    const duration = moment.duration(difference);
    return Math.floor(duration.asMinutes()) + '';
  }
  return null;
}

export default{
  userLocalDateTimeFormat,
  getDurationAsMinute,
};